/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type layoutCorpoData$ref: FragmentReference;
declare export opaque type layoutCorpoData$fragmentType: layoutCorpoData$ref;
export type layoutCorpoData = {|
  +ref: string,
  +name: ?string,
  +fidelityLevel: ?number,
  +isFidelityActive: boolean,
  +subscription: ?any,
  +fidelityProgress: ?{|
    +year: number,
    +yearBookings: number,
    +bookingsToNextTier: number,
    +bookingsToMaintain: number,
    +validUntil: ?any,
  |},
  +teamName: ?string,
  +formatted_address: ?string,
  +siret: ?any,
  +tvaNumber: ?string,
  +invoiceEmails: ?$ReadOnlyArray<?any>,
  +params: ?{|
    +allowEmailDomain: ?$ReadOnlyArray<?string>,
    +automaticApprouval: ?boolean,
    +manualApprouval: ?boolean,
    +automaticDeniedOtherEmailDomain: ?boolean,
    +manualOtherEmailDomain: ?boolean,
  |},
  +payment: ?{|
    +isSepa: ?boolean,
    +transferMode: ?string,
    +mandateUrl: ?string,
  |},
  +users: ?$ReadOnlyArray<?{|
    +ref: ?string,
    +roles: ?string,
    +status: ?string,
    +email: ?any,
    +user: ?{|
      +email: any,
      +lastname: ?string,
      +firstname: ?string,
    |},
    +adminNeedValid: ?boolean,
    +emails: ?$ReadOnlyArray<?{|
      +template: ?string,
      +limitDate: ?any,
    |}>,
  |}>,
  +$refType: layoutCorpoData$ref,
|};
export type layoutCorpoData$data = layoutCorpoData;
export type layoutCorpoData$key = {
  +$data?: layoutCorpoData$data,
  +$fragmentRefs: layoutCorpoData$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ref",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "layoutCorpoData",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fidelityLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFidelityActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subscription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CorpoFidelityProgress",
      "kind": "LinkedField",
      "name": "fidelityProgress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "year",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "yearBookings",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bookingsToNextTier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bookingsToMaintain",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "validUntil",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formatted_address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "siret",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tvaNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiceEmails",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CorpoParams",
      "kind": "LinkedField",
      "name": "params",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowEmailDomain",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "automaticApprouval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "manualApprouval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "automaticDeniedOtherEmailDomain",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "manualOtherEmailDomain",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CorpoPayment",
      "kind": "LinkedField",
      "name": "payment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSepa",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "transferMode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mandateUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CorpoUser",
      "kind": "LinkedField",
      "name": "users",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roles",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastname",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstname",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "adminNeedValid",
          "args": [
            {
              "kind": "Literal",
              "name": "what",
              "value": "NEEDAPPROVAL"
            }
          ],
          "kind": "ScalarField",
          "name": "is",
          "storageKey": "is(what:\"NEEDAPPROVAL\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CorpoUserEmail",
          "kind": "LinkedField",
          "name": "emails",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "template",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "limitDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Corpo",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'aea6c1e09756ba8533ba80fd422542c4';

module.exports = node;
